(function () {
  'use strict';

  window.kiidBundleBuilder = function () {
    return {
      selected: [],
      giftBundle: false,
      giftBundleMode: false,
      subscribe: false,
      loading: false,
      cardColors: {},
      availability: {},
      unitPrices: {},
      defaultUnitPrice: 1400,
      selectedSizeLabel: '12 Servings',
      _pv: {},
      _pn: {},
      _sp: {},
      _gbv: null,
      _cupVariantId: null,
      _mixerVariantId: null,
      _cupTitle: 'Official Kiid Cup',
      _mixerTitle: 'Electric Mixer',

      init: function () {
        var raw = this.$el.getAttribute('data-config') || '{}';
        var data;
        try { data = JSON.parse(raw); } catch (e) { data = {}; }
        this.defaultUnitPrice = data.defaultUnitPrice || 1400;
        this._pv = data.productVariants || {};
        this._pn = data.productNames || {};
        this._sp = data.sellingPlanIds || {};
        this.availability = data.availability || {};
        this.unitPrices = data.unitPrices || {};
        this._gbv = data.giftBundleVariantId || null;
        this._cupVariantId = data.cupVariantId || null;
        this._mixerVariantId = data.mixerVariantId || null;
        this._cupTitle = data.cupTitle || 'Official Kiid Cup';
        this._mixerTitle = data.mixerTitle || 'Electric Mixer';
        this.giftBundleMode = data.giftBundleMode || false;
        if (this.giftBundleMode) this.giftBundle = true;
      },

      isAvailable: function (handle) {
        return this.availability[handle] !== false;
      },

      priceFor: function (handle) {
        var p = this.unitPrices[handle];
        return (p === undefined || p === null) ? this.defaultUnitPrice : p;
      },

      displayPriceFor: function (handle) {
        var base = this.priceFor(handle);
        if (this.selected.includes(handle) && this.discount() < 1) {
          return Math.round(base * this.discount());
        }
        return base;
      },

      shadowStyle: function (handle) {
        var c = this.cardColors[handle];
        if (this.selected.length >= 3 && !this.selected.includes(handle)) return 'box-shadow:none';
        var shadow = c ? c.shadow : '#48eb66';
        var size = this.selected.includes(handle) ? '10px 10px' : '8px 8px';
        return 'box-shadow:' + size + ' 0 ' + shadow;
      },

      toggle: function (handle) {
        if (!this.isAvailable(handle)) return;
        var idx = this.selected.indexOf(handle);
        if (idx > -1) this.selected.splice(idx, 1);
        else if (this.selected.length < 3) this.selected.push(handle);
        if (!this.giftBundleMode && this.selected.length < 3) this.giftBundle = false;
      },

      discount: function () {
        return this.selected.length >= 3 ? 0.85 : this.selected.length >= 2 ? 0.90 : 1;
      },

      rawTotal: function () {
        var self = this;
        return this.selected.reduce(function (sum, handle) {
          return sum + self.priceFor(handle);
        }, 0);
      },

      bundleTotal: function () {
        return Math.round(this.rawTotal() * this.discount());
      },

      giftBundlePrice: function () {
        var avg = this.selected.length ? this.rawTotal() / this.selected.length : this.defaultUnitPrice;
        return avg <= 1500 ? 4800 : 7400;
      },

      giftBundleSavingsAmount: function () {
        return (this.rawTotal() + 999 + 900) - this.giftBundlePrice();
      },

      displayTotal: function () {
        if (this.giftBundle && this.selected.length >= 3) return this.giftBundlePrice();
        return this.bundleTotal();
      },

      savings: function () {
        return this.rawTotal() - this.bundleTotal();
      },

      formatMoney: function (cents) {
        return '$' + (cents / 100).toFixed(2);
      },

      addToCart: function () {
        if (this.selected.length === 0 || this.loading) return;
        var self = this;
        self.loading = true;
        var pv = this._pv;
        var sp = this._sp;
        var items;

        var availableSelected = self.selected.filter(function (handle) {
          return self.isAvailable(handle);
        });

        if (self.giftBundle && availableSelected.length >= 3) {
          var bundleId = 'gift-bundle-' + Date.now();
          items = [];
          availableSelected.slice(0, 3).forEach(function (handle, i) {
            var variantId = (pv[handle] && pv[handle][self.selectedSizeLabel])
                            || Object.values(pv[handle] || {})[0];
            if (variantId) {
              items.push({
                id: variantId,
                quantity: 1,
                properties: {
                  '_bundle_id': bundleId,
                  '_bundle_type': 'gift-bundle',
                  '_bundle_role': 'flavor-' + (i + 1)
                }
              });
            }
          });
          if (self._cupVariantId) {
            items.push({
              id: self._cupVariantId,
              quantity: 1,
              properties: {
                '_bundle_id': bundleId,
                '_bundle_type': 'gift-bundle',
                '_bundle_role': 'cup'
              }
            });
          }
          if (self._mixerVariantId) {
            items.push({
              id: self._mixerVariantId,
              quantity: 1,
              properties: {
                '_bundle_id': bundleId,
                '_bundle_type': 'gift-bundle',
                '_bundle_role': 'mixer'
              }
            });
          }
        } else {
          var bundleId = 'bundle-' + Date.now();
          items = availableSelected.map(function (handle) {
            var variantId = (pv[handle] && pv[handle][self.selectedSizeLabel])
                            || Object.values(pv[handle] || {})[0];
            var item = {
              id: variantId,
              quantity: 1,
              properties: {
                '_bundle_id': bundleId,
                '_bundle_discount': availableSelected.length >= 3 ? '15%' : availableSelected.length >= 2 ? '10%' : ''
              }
            };
            if (self.subscribe && sp[handle]) item.selling_plan = sp[handle];
            return item;
          }).filter(function (it) { return it.id; });
        }

        if (!items.length) {
          self.loading = false;
          alert('Could not match flavors to variants. Check the Flavour collection in the theme editor.');
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          window.location.href = '/cart';
        }).catch(function () {
          self.loading = false;
          alert('Something went wrong adding to cart. Please try again.');
        });
      }
    };
  };

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('kiid-bundle-builder');
    if (!root) return;

    function extractColors() {
      if (typeof ColorThief === 'undefined' || typeof Alpine === 'undefined') return;
      var thief = new ColorThief();
      root.querySelectorAll('[data-handle]').forEach(function (card) {
        var handle = card.dataset.handle;
        var img = card.querySelector('img');
        if (!img) return;
        function apply() {
          try {
            var rgb = thief.getColor(img);
            var alpineData = Alpine.$data(root);
            if (alpineData) alpineData.cardColors[handle] = {
              shadow: 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')'
            };
          } catch (e) {}
        }
        if (img.complete && img.naturalWidth > 0) apply();
        else img.addEventListener('load', apply);
      });
    }

    document.addEventListener('alpine:initialized', extractColors);
    window.addEventListener('load', function () { setTimeout(extractColors, 300); });
  });

})();
